import { render, staticRenderFns } from "./SectionEditorView.vue?vue&type=template&id=dcb3fee2&"
import script from "./SectionEditorView.vue?vue&type=script&lang=js&"
export * from "./SectionEditorView.vue?vue&type=script&lang=js&"
import style0 from "./SectionEditorView.vue?vue&type=style&index=0&id=dcb3fee2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports